import React from 'react';
import { Modal } from '@gerdau/hefesto';

interface CancelUploadFilesProps {
  onCancelClick: () => void;
  onContinueClick: () => void;
}

const CancelUploadFiles: React.FC<CancelUploadFilesProps> = ({
  onCancelClick,
  onContinueClick
}) => {
  return (
    <Modal
      buttons={{
        left: {
          children: 'Continuar',
          name: 'continue-upload',
          onClick: onContinueClick,
          type: 'button',
          variant: 'secondary'
        },
        right: {
          children: 'Cancelar upload',
          name: 'cancel-upload-confirm',
          onClick: onCancelClick,
          type: 'button',
          variant: 'danger'
        }
      }}
      modalSize="sm"
      title="Cancelar upload dos arquivos?"
    >
      <span>
        Deseja cancelar o upload dos arquivos não enviados? <br />
        Isso não afetará os que já foram preenchidos.
      </span>
    </Modal>
  );
};

export default CancelUploadFiles;
